import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
@Directive({
    selector: '[aimoClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
    @Output() clickOutsideEvent = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {}

    @HostListener('document:click', ['$event.target'])
    public onClick(target): void {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickOutsideEvent.emit();
        }
    }
}
